import styles from "gui/hero/hero.module.css";
import { ButtonOld } from "components/ButtonOld/ButtonOld";
import { Grid } from "gui/grid/grid";
import { Icon } from "gui/icon/icon";
import { SanityHero } from "lib/sanity/types";
import { Spacer } from "gui/spacer/spacer";

export const Hero: React.FC<{
  item: SanityHero;
}> = (props) => {
  const id = `aria-${props.item._key}`;

  return (
    <>
      <Spacer at="lg" />
      <Grid aria-labelledby={id} revealOnLoad gaps>
        <div className={styles.square}>
          <header>
            <h1 id={id} className={styles.title}>
              {props.item.title}
            </h1>
          </header>
          <ButtonOld href={props.item.link} size="lg" color1>
            {props.item.action}
            <Icon icon="arrow-right" />
          </ButtonOld>
        </div>
        <div className={styles.pitch}>
          <p>{props.item.subtitle}</p>
          <ul>
            {props.item.list.map((item, i) => (
              <li key={i}>
                <Icon icon={item.icon} />
                {item.text}
              </li>
            ))}
          </ul>
        </div>
      </Grid>
    </>
  );
};
